import type { ReactElement } from "react";
import React from "react";

import { toast } from "sonner";

import { getDisplayName } from "../../utils/react";

// Функция обертка над тостом. Принимает в себя саму верстку, нужный duration и position.

const TOAST_DURATIONS = {
    SHORT: 4000, // компонент тоста без ButtonsView
    LONG: 8000, // компонент тоста с ButtonsView
    INFINITE: Number.POSITIVE_INFINITY, // бесконечный тост
} as const;

type ToastDuration = (typeof TOAST_DURATIONS)[keyof typeof TOAST_DURATIONS];

type ToastPosition =
    | "top-left"
    | "top-center"
    | "top-right"
    | "bottom-left"
    | "bottom-center"
    | "bottom-right";

export const showToast = (props: {
    toastComponent: React.ReactElement;
    duration?: ToastDuration;
    position?: ToastPosition;
}) => {
    const hasButtonsView = checkForButtonsView(props.toastComponent);
    const duration =
        props.duration ??
        (hasButtonsView ? TOAST_DURATIONS.LONG : TOAST_DURATIONS.SHORT);
    return toast.custom(() => props.toastComponent, {
        duration,
        position: props.position ?? "bottom-right",
    });
};

function checkForButtonsView(element: ReactElement): boolean {
    const displayName = getDisplayName(element);
    if (displayName === "Toast.ButtonsView") {
        return true;
    }

    if (element.props.children) {
        const children = Array.isArray(element.props.children)
            ? element.props.children
            : [element.props.children];

        return children.some(
            (child: React.ReactNode) =>
                React.isValidElement(child) && checkForButtonsView(child),
        );
    }

    return false;
}
